enum RoleType {
  AGENT,
  SUPERVISOR,
}

export default RoleType;
